import { useTranslation } from "next-i18next";

const useJobTranslation = () => {
  return useTranslation("job");
};

export default useJobTranslation;
